import { render } from "./SoupBody.vue?vue&type=template&id=1a88d587&scoped=true"
import script from "./SoupBody.vue?vue&type=script&lang=js"
export * from "./SoupBody.vue?vue&type=script&lang=js"

import "./SoupBody.vue?vue&type=style&index=0&id=1a88d587&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a88d587"]])

export default __exports__